export const state = {
  labUnits: null,
}

export const getters = {
  getLabUnits(state) {
    return state.labUnits ? state.labUnits : null
  },
}

export const mutations = {
  SET_LAB_UNITS(state, newValue) {
    state.labUnits = newValue
  },
}

export const actions = {
  setLabUnits({ commit, state }, payload) {
    if (payload) {
      commit('SET_LAB_UNITS', payload)
      return payload
    }
    return null
  },
}
